<template>
    <div class="sidebar-outline" :class="{closed: isClose, top: isTop}">
        <button type="button"
            id="btn-toggle"
            class="btn btn-outline-secondary btn-lg"
            :style="buttonStyle"
            :class="{closed: isClose, cloudy: isWriting}"
            @click="toggle()">
            <i class="fas fa-images" v-if="isClose || (!isClose && !isTop)"></i>
            <i class="fas fa-times" v-else></i>
        </button>
        <div class="sidebar" id="content-sidebar" :class="{closed: isClose}">
            <div class="sidebar-body">
                <div class="sidebar-wrapper">
                    <div class="sticky" style="top:0">
                        <button type="button" class="btn btn-light btn-block btn-square" @click="toggle()">
                            閉じる
                            <i class="fas fa-chevron-right"></i>
                        </button>
                    </div>
                    <div class="p-3">
                        <div class="d-flex justify-content-center flex-wrap" v-if="backgrounds.length">
                            <div class="card bg-card m-2" v-for="v in backgrounds" :key="v.id">
                                <div class="img-column">
                                    <img :src="v.picture.url" class="mx-auto d-block cover" v-if="v.picture" />
                                    <img :src="v.url" class="mx-auto d-block cover" v-else />
                                </div>
                                <div class="card-footer text-right">
                                    <button type="button" class="btn btn-outline-danger btn-sm" @click="remove(v)">
                                        <i class="fas fa-times-circle"></i>
                                        削除
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="nothing" v-else>
                            <p>
                                このエピソードの背景画像はありません。
                            </p>
                            <p>
                                背景は最大 {{$store.state.max_background_episode}} 枚追加できます。
                            </p>
                        </div>
                        <ul class="nav nav-tabs mb-3">
                            <li class="nav-item">
                                <a href="#" class="nav-link" :class="{active: type == 'url'}" @click.prevent="changeType('url')">外部URL</a>
                            </li>
                            <li class="nav-item">
                                <a href="#" class="nav-link" :class="{active: type == 'upload'}" @click.prevent="changeType('upload')">画像アップロード</a>
                            </li>
                        </ul>
                        <div v-if="type == 'url'">
                            <div class="mb-3">
                                <div class="input-group">
                                    <input type="text" v-model="url" class="form-control"
                                        placeholder="背景のURLを追加してEnter"
                                        :disabled="backgrounds.length >= $store.state.max_background_episode"
                                        @keydown.enter="save()">
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-primary btn-sm" @click="save()" :disabled="urlDisabled">
                                            追加
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3" v-if="url">
                                <label>表示確認</label>
                                <img :src="url" class="img-fluid img-thumbnail">
                            </div>
                        </div>
                        <div v-if="type == 'upload'">
                            <div class="d-flex justify-content-center mb-3">
                                <div class="btn-group file-selector">
                                    <label class="btn btn-secondary" style="margin: 0;" for="image">
                                        <i class="fas fa-file-image"></i>
                                        背景画像選択...
                                        <input type="file" id="image" ref="image" @change="fileSelected()" accept="image/*" class="d-none" />
                                    </label>
                                    <button type="button" @click="removeImage()" class="btn btn-light">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>
                            <div v-if="$store.getters.user" class="mb-3">
                                <div>
                                    現在使用中の画像ストレージ
                                </div>
                                <picture-storage :curr="curr" :max="$store.getters.user.storage_limit"></picture-storage>
                            </div>
                            <div class="mb-3 d-flex justify-content-end">
                                <button class="btn btn-outline-primary" @click="save()" :disabled="fileDisabled">
                                    アップロード
                                </button>
                            </div>
                            <div class="d-flex justify-content-center mb-3" v-if="file.url">
                                <img :src="file.url" class="img-fluid preview" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <loading
            v-model:active="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
    </div>
</template>

<style src="./sidebar.scss" scoped lang="scss"></style>
<style scoped lang="scss">
.cover {
    object-fit: cover;
    height: 100%;
    width: 83px;
    position: relative;
}
.bg-card {
    width: 213px;
    overflow: hidden;
    margin-left: auto;
    margin-right: auto;
    .img-column {
        background-color: black;
        position: relative;
        height: 300px;
        .cover {
            object-fit: cover;
            width: 213px;
            height: 300px;
        }
    }
}
.preview {
    border-radius: .5rem;
}
</style>

<script>
import PictureStorage from "components/PictureStorage";
export default {
    components: {
        PictureStorage
    },
    props: {
        section_id: {
            required: true,
        },
        order: {
            default: 5
        },
        isWriting: {
            default: false,
        },
    },
    data() {
        return {
            isClose: true,
            isTop: false,
            isLoading: false,
            backgrounds: [],
            url: null,
            type: "url",
            curr: 0,
            file: {
                info: null,
                url: null,
            },
        }
    },
    methods: {
        load() {
            this.file = {
                info: null,
                url: null,
            };
            this.url = null;
            if (this.section_id === "new") {
                this.backgrounds = [];
                return;
            }
            axios.get("/mypage/backgrounds/get", {params: {section_id: this.section_id}}).then(res => {
                this.backgrounds = res.data.backgrounds;
                this.curr = res.data.curr;
            }).catch(err => { alert.err(err.response); });
        },
        save() {
            const fd = new FormData();
            if (this.file.info) {
                fd.append('info', this.file.info);
                fd.append('url', this.file.url);
            } else if (this.url) {
                fd.append('url', this.url);
            } else {
                return;
            }
            this.isLoading = true;
            fd.append('section_id', this.section_id);
            axios.post("/mypage/background/save", fd).then(res => {
                alert.msg("保存しました。");
                this.url = null;
                this.isLoading = false;
                this.load();
            }).catch(err => {
                alert.err(err);
                this.isLoading = false;
            });
        },
        toggle(isClose = null) {
            if (isClose !== null) {
                this.isClose = isClose;
                this.isTop = false;
            } else {
                if (!this.isClose && !this.isTop) {
                    this.isTop = true;
                } else {
                    this.isClose = !this.isClose;
                    this.isTop = !this.isClose;
                }
                this.$emit("toggle", this.isClose);
            }
        },
        remove(v) {
            Swal.fire({
                title: "背景画像削除",
                text: "背景画像を削除します。\nよろしいですか？",
                html: `以下の画像を削除します。<div><img src="${v.url}" class="img-fluid img-thumbnail"></div>`,
                icon: "error",
                showCancelButton: true,
                confirmButtonText: "削除",
                cancelButtonText: "キャンセル",
                confirmButtonColor: "crimson",
                cancelButtonColor: "gray",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    this.isLoading = true;
                    axios.post("/mypage/background/remove", {id: v.id}).then(res => {
                        alert.msg("背景画像を削除しました。");
                        this.$store.state.backgroundCallback(true);
                        this.load();
                        this.isLoading = false;
                    }).catch(err => { alert.err(err.response) });
                }
            });
        },
        removeImage() {
            this.file.info = null;
            this.file.url = "";
        },
        changeType(type) {
            if (type !== this.type) {
                this.type = type;
                // すべてリセットする
                this.removeImage();
                this.url = null;
            }
        },
        fileSelected() {
            if (this.$refs.image.files[0].size > 5000 * 1024) {
                alert.err("ファイルサイズが大きすぎます: " + this.$filters.getByte(this.$refs.image.files[0].size));
                return;
            }
            this.file.info = this.$refs.image.files[0];
            this.file.url = URL.createObjectURL(this.file.info);
        },
    },
    watch: {
        section_id(n, o) {
            this.load();
        }
    },
    computed: {
        buttonStyle() { return { "top": (this.order * 46 + 50) + "px" }; },
        fileDisabled() {
            if (!this.file.url) {
                return true;
            }
            if (this.section_id === "new") {
                return true;
            }
            return false;
        },
        urlDisabled() {
            if (!this.url) {
                 return true;
            }
            if (this.section_id === "new") {
                return true;
            }
            return false;
        },
    },
    mounted() {
        this.load();
    }
}
</script>